import { router } from "expo-router";
import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { StyleSheet } from "react-native";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { Spacer } from "../Spacer";
import { Pressable } from "./Pressable";
import { TabButton } from "./TabButton";
import { BodyText } from "./Text/BodyText";
import { BrandText } from "./Text/BrandText";
import type { PressableState } from "./Pressable";

const S = StyleSheet.create({
  helpCard: {
    backgroundColor: styleConstantsV2.colorSecondaryBg,
    paddingHorizontal: 16,
    paddingVertical: 18,
    borderRadius: styleConstantsV2.borderRadius4,
  },
});

export const TabCard = observer(function TabCard() {
  const [isPressed, setIsPressed] = useState(false);

  const resolveBackgroundColor = useCallback((state: PressableState) => {
    if (state.pressed) {
      return styleConstantsV2.colorSecondaryHoverLight;
    }
    if (state.hovered) {
      return styleConstantsV2.colorSecondaryHoverLight;
    }
    return styleConstantsV2.colorSecondaryBg;
  }, []);

  return (
    <Pressable
      onPress={() => {
        router.navigate("/(app)/book-appointment");
      }}
      onPressIn={() => {
        setIsPressed(true);
      }}
      onPressOut={() => {
        setIsPressed(false);
      }}
      style={(state) => {
        return [
          S.helpCard,
          {
            backgroundColor: resolveBackgroundColor(state),
          },
        ];
      }}
    >
      <BrandText sizeH3 weightBold colorBlack>
        <FormattedMessage
          id="pQJao5"
          defaultMessage="How can we help you?"
          description="Text inside help card"
        />
      </BrandText>
      <Spacer small />
      <BodyText colorBlack sizeLarge weightRegular>
        <FormattedMessage
          id="cOcLsR"
          defaultMessage="When your pet needs care, we’re here to help with anything."
          description="Help card text"
        />
      </BodyText>
      <Spacer large />

      <TabButton
        iconName="calendar"
        title={intl.formatMessage({
          id: "S6hFuf",
          defaultMessage: "Book clinic visit",
          description: "Book clinic visit text",
        })}
        backgroundColor={
          isPressed ? styleConstantsV2.colorGrey20 : styleConstantsV2.colorWhite
        }
        pointerEvents="none"
      />
    </Pressable>
  );
});
